/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import { useFocusMode } from "../../components/focusMode";
import { BaseButton } from "./BaseButton";
import { LodestarAndUrsaButtonProps } from "./types";

export type ButtonProps = LodestarAndUrsaButtonProps;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ type = "button", appearance = "primary", ...props }, ref) => {
        if (process.env.NODE_ENV !== "production") {
            if (
                !props.children &&
                (props.iconBefore || props.iconAfter) &&
                !props["aria-label"] &&
                !props["aria-labelledby"]
            ) {
                console.warn("No aria-label or aria-labelledby provided to ICON-ONLY BUTTON component!");
            }
        }

        const { focusMode } = useFocusMode({
            isDisabled: appearance !== "borderless",
        });
        return (
            <BaseButton
                {...props}
                appearance={appearance}
                type={type}
                innerRef={ref}
                focusMode={focusMode}
                renderAs={"button"}
            />
        );
    }
);
